import { render } from "./Bajas.vue?vue&type=template&id=8b296bce&scoped=true"
import script from "./Bajas.vue?vue&type=script&lang=js"
export * from "./Bajas.vue?vue&type=script&lang=js"

import "./Bajas.vue?vue&type=style&index=0&id=8b296bce&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b296bce"]])

export default __exports__